import React from "react";
import { Modal } from "react-bootstrap";
import ViewForm from "../../Components/ApplicantProcessing/ViewForm";

const VIEW_FORM_MODAL_STYLES = {
    modalContent: {
        borderRadius: "0",
        overflow: "hidden",
        border: "1px solid #e2e8f0",
        boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
    },
    header: {
        padding: "18px 22px",
        borderBottom: "1px solid #e2e8f0",
        backgroundColor: "#ffffff"
    },
    headerContent: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "14px"
    },
    modalFooter: {
        padding: "16px 22px 20px",
        borderTop: "1px solid #e2e8f0",
        backgroundColor: "#ffffff"
    },
    titleWrap: {
        display: "flex",
        alignItems: "center",
        gap: "14px"
    },
    headerIcon: {
        width: "46px",
        height: "46px",
        borderRadius: "0",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f1f5f9",
        border: "1px solid #cbd5e1",
        color: "#0f172a",
        fontSize: "21px",
        boxShadow: "none"
    },
    title: {
        fontSize: "22px",
        fontWeight: 600,
        color: "#0f172a",
        lineHeight: 1.1,
        margin: 0
    },
    subtitle: {
        fontSize: "12px",
        color: "#64748b",
        marginTop: "4px"
    },
    closeButton: {
        width: "38px",
        height: "38px",
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        backgroundColor: "#ffffff",
        color: "#64748b",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        flexShrink: 0
    },
    body: {
        padding: "20px 22px 22px 22px",
        backgroundColor: "#ffffff"
    },
    helperCard: {
        borderRadius: "0",
        padding: "16px",
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        marginBottom: "16px"
    },
    helperTitle: {
        fontSize: "14px",
        fontWeight: 600,
        color: "#0f172a",
        marginBottom: "8px"
    },
    helperText: {
        fontSize: "12px",
        lineHeight: 1.7,
        color: "#64748b",
        margin: 0
    },
    formFrame: {
        height: "min(68vh, 640px)",
        overflow: "auto",
        borderRadius: "0",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff"
    },
    formContent: {
        padding: "18px"
    },
    footerActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        flexWrap: "wrap"
    },
    cancelButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    }
};

const ViewFormModal = (props) => {
    const { handleViewForm, viewFormShowHide,
        workflowTask, selectedForm, handleFormUpdate, allowEdit, formName = "" } = props;
    return (
        <Modal
            show={viewFormShowHide}
            centered
            dialogClassName="custom-inline-dialog"
            contentClassName="view-form-modal-content"
        >
            <style>
                {`
                  .custom-inline-dialog {
                    max-width: min(1120px, 92vw) !important;
                    width: min(1120px, 92vw) !important;
                  }

                  .view-form-modal-content {
                    border-radius: ${VIEW_FORM_MODAL_STYLES.modalContent.borderRadius};
                    overflow: ${VIEW_FORM_MODAL_STYLES.modalContent.overflow};
                    border: ${VIEW_FORM_MODAL_STYLES.modalContent.border};
                    box-shadow: ${VIEW_FORM_MODAL_STYLES.modalContent.boxShadow};
                  }
                `}
            </style>
            <Modal.Header style={VIEW_FORM_MODAL_STYLES.header}>
                <div style={VIEW_FORM_MODAL_STYLES.headerContent}>
                    <Modal.Title as="div" style={VIEW_FORM_MODAL_STYLES.titleWrap}>
                        <div style={VIEW_FORM_MODAL_STYLES.headerIcon}>
                            <i className={allowEdit ? "fa fa-pencil-square-o" : "fa fa-file-text-o"} aria-hidden="true"></i>
                        </div>
                        <div>
                            <div style={VIEW_FORM_MODAL_STYLES.title}>{formName || "Form Details"}</div>
                            <div style={VIEW_FORM_MODAL_STYLES.subtitle}>
                                {allowEdit ? "Review the form details and make updates where editing is enabled." : "Review the submitted form details in read-only mode."}
                            </div>
                        </div>
                    </Modal.Title>
                    <button
                        type="button"
                        style={VIEW_FORM_MODAL_STYLES.closeButton}
                        onClick={handleViewForm}
                        aria-label="Close form popup"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body style={VIEW_FORM_MODAL_STYLES.body}>
                <div style={VIEW_FORM_MODAL_STYLES.helperCard}>
                    <div style={VIEW_FORM_MODAL_STYLES.helperTitle}>Form review</div>
                    <p style={VIEW_FORM_MODAL_STYLES.helperText}>
                        Check the submitted details below. When edit access is enabled, update the necessary fields and save from inside the form.
                    </p>
                </div>

                <div style={VIEW_FORM_MODAL_STYLES.formFrame}>
                    <div style={VIEW_FORM_MODAL_STYLES.formContent}>
                        <ViewForm
                            formShowHide={viewFormShowHide}
                            handleFormShowHide={handleViewForm}
                            workflowTask={workflowTask}
                            selectedForm={selectedForm}
                            handleFormUpdate={handleFormUpdate}
                            allowEdit={allowEdit}
                        ></ViewForm>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={VIEW_FORM_MODAL_STYLES.modalFooter}>
                <div style={VIEW_FORM_MODAL_STYLES.footerActions}>
                    <button
                        type="button"
                        style={VIEW_FORM_MODAL_STYLES.cancelButton}
                        onClick={handleViewForm}
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );

}

export default ViewFormModal;
